import React from 'react';
//import { Button } from 'reactstrap';
import Button from '@mui/material/Button';
const ButtonC = (props) => {
    return(
        <Button color={props.color} hidden={props.hidden} outline={props.outline} className={props.className}  onClick={props.onClick} disabled={props.outline? false: props.disabled/*props.data ? props.data : props.disabled*/} >
        <span style={props.style1} >{props.label}</span>
    </Button>
    )
}

export default ButtonC;